import React from 'react';
import { MainLayout } from '../layouts/MainLayout';
import { Card } from '../components/ui/Card';
import { MetricCard } from '../components/dashboard/MetricCard';
import { ActivityFeed } from '../components/dashboard/ActivityFeed';
import { Activity } from '../types';
import { Server, Ticket, ShoppingCart, TrendingUp, AlertTriangle, CheckCircle } from 'lucide-react';
interface DashboardProps {
  onLogout: () => void;
}
const mockActivities: Activity[] = [{
  id: '1',
  type: 'ticket',
  message: 'Neues Ticket #1042 von Müller GmbH erstellt',
  timestamp: 'vor 5 Min',
  user: 'System'
}, {
  id: '2',
  type: 'system',
  message: 'Server SRV-DC-01 erfolgreich aktualisiert',
  timestamp: 'vor 23 Min',
  user: 'Admin'
}, {
  id: '3',
  type: 'order',
  message: 'Bestellung #ORD-2023-005 bei Ingram aufgegeben',
  timestamp: 'vor 1 Std',
  user: 'Max Mustermann'
}, {
  id: '4',
  type: 'security',
  message: 'Firewall-Regel für Client Schmidt KG aktualisiert',
  timestamp: 'vor 2 Std',
  user: 'Admin'
}, {
  id: '5',
  type: 'ticket',
  message: 'Ticket #1038 wurde geschlossen',
  timestamp: 'vor 3 Std',
  user: 'Lisa Schmidt'
}];
export function Dashboard({
  onLogout
}: DashboardProps) {
  return <MainLayout title="Dashboard" onLogout={onLogout} data-id="element-352">
      {/* Metrics Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-353">
        <MetricCard title="Aktive Assets" value="247" change="+12%" trend="up" icon={<Server className="h-5 w-5" data-id="element-355" />} data-id="element-354" />
        <MetricCard title="Offene Tickets" value="18" change="-23%" trend="down" icon={<Ticket className="h-5 w-5" data-id="element-357" />} data-id="element-356" />
        <MetricCard title="Bestellungen" value="34" change="+8%" trend="up" icon={<ShoppingCart className="h-5 w-5" data-id="element-359" />} data-id="element-358" />
        <MetricCard title="System Health" value="98.2%" change="+0.3%" trend="up" icon={<TrendingUp className="h-5 w-5" data-id="element-361" />} data-id="element-360" />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-362">
        <Card title="Kritische Warnungen" data-id="element-363">
          <div className="space-y-4" data-id="element-364">
            <div className="flex items-start gap-3 p-3 bg-red-50 rounded-lg border border-red-100" data-id="element-365">
              <AlertTriangle className="h-5 w-5 text-red-600 mt-0.5" data-id="element-366" />
              <div data-id="element-367">
                <h4 className="font-medium text-red-900" data-id="element-368">
                  Firewall Update ausstehend
                </h4>
                <p className="text-sm text-red-700 mt-1" data-id="element-369">
                  Kritisches Sicherheitsupdate für 3 Firewalls verfügbar
                </p>
              </div>
            </div>
            <div className="flex items-start gap-3 p-3 bg-amber-50 rounded-lg border border-amber-100" data-id="element-370">
              <AlertTriangle className="h-5 w-5 text-amber-600 mt-0.5" data-id="element-371" />
              <div data-id="element-372">
                <h4 className="font-medium text-amber-900" data-id="element-373">
                  Backup-Fehler erkannt
                </h4>
                <p className="text-sm text-amber-700 mt-1" data-id="element-374">
                  Letztes Backup für Server-03 fehlgeschlagen
                </p>
              </div>
            </div>
          </div>
        </Card>

        <ActivityFeed activities={mockActivities} data-id="element-375" />
      </div>

      <Card title="System Status" data-id="element-376">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-377">
          <div className="text-center p-4 bg-emerald-50 rounded-lg" data-id="element-378">
            <CheckCircle className="h-8 w-8 text-emerald-600 mx-auto mb-2" data-id="element-379" />
            <div className="text-2xl font-bold text-emerald-900" data-id="element-380">234</div>
            <div className="text-sm text-emerald-700" data-id="element-381">Online</div>
          </div>
          <div className="text-center p-4 bg-slate-50 rounded-lg" data-id="element-382">
            <Server className="h-8 w-8 text-slate-600 mx-auto mb-2" data-id="element-383" />
            <div className="text-2xl font-bold text-slate-900" data-id="element-384">13</div>
            <div className="text-sm text-slate-700" data-id="element-385">Wartung</div>
          </div>
          <div className="text-center p-4 bg-red-50 rounded-lg" data-id="element-386">
            <AlertTriangle className="h-8 w-8 text-red-600 mx-auto mb-2" data-id="element-387" />
            <div className="text-2xl font-bold text-red-900" data-id="element-388">3</div>
            <div className="text-sm text-red-700" data-id="element-389">Offline</div>
          </div>
          <div className="text-center p-4 bg-blue-50 rounded-lg" data-id="element-390">
            <TrendingUp className="h-8 w-8 text-blue-600 mx-auto mb-2" data-id="element-391" />
            <div className="text-2xl font-bold text-blue-900" data-id="element-392">98.2%</div>
            <div className="text-sm text-blue-700" data-id="element-393">Uptime</div>
          </div>
        </div>
      </Card>
    </MainLayout>;
}